import React, { FC } from 'react';
import {
  CollaborativeSource,
  CreateAppointmentOptions,
  CreateNoteOptions,
  CreateReminderOptions,
  CreateTaskOptions,
} from 'src/interfaces/api/Collaborative';
import PlanningAction from './PlanningAction';
import useTicket from 'src/hooks/api/useTicket';
import { useSetRecoilState } from 'recoil';
import ticketsState from 'src/recoil/atoms/tickets';
import Ticket from 'src/interfaces/api/Ticket';

interface Props {
  className?: string;
  ticketId: string;
}

const PlanningActionContainer: FC<Props> = ({ ticketId, ...props }) => {
  const { addAppointment, addNote, addTask, addReminder } = useTicket();
  const setTickets = useSetRecoilState(ticketsState);

  const source: CollaborativeSource = {
    id: ticketId,
    type: 'ticket',
  };

  const handleAddAppointment = async (options: CreateAppointmentOptions) => {
    const newTicket = await addAppointment(ticketId, options);
    updateTicket(newTicket);
  };

  const handleAddNote = async (options: CreateNoteOptions) => {
    const newTicket = await addNote(ticketId, options);
    updateTicket(newTicket);
  };

  const handleAddTask = async (options: CreateTaskOptions) => {
    const newTicket = await addTask(ticketId, options);
    updateTicket(newTicket);
  };

  const handleAddReminder = async (options: CreateReminderOptions) => {
    const newTicket = await addReminder(ticketId, options);
    updateTicket(newTicket);
  };

  const updateTicket = (newTicket: Ticket) => {
    setTickets((tickets) => {
      const newTickets = { ...tickets };
      newTickets[newTicket.id] = newTicket;

      return newTickets;
    });
  };

  return (
    <PlanningAction
      onAddNote={handleAddNote}
      onAddTask={handleAddTask}
      onAddReminder={handleAddReminder}
      onAddAppointment={handleAddAppointment}
      collaborativeSource={source}
      {...props}
    />
  );
};

export default PlanningActionContainer;
